export const FETCH_PAYMENT_METHODS_SUCCESS =
  'iron/payments/FETCH_PAYMENT_MEHTODS_SUCCESS';
export const FETCH_PAYMENT_METHODS_FAILURE =
  'iron/payments/FETCH_PAYMENT_MEHTODS_FAILURE';

export const fetchPaymentMethodsSuccess = (localMethods) => ({
  type: FETCH_PAYMENT_METHODS_SUCCESS,
  payload: { localMethods },
});

export const fetchPaymentMethodsFailure = (error) => ({
  type: FETCH_PAYMENT_METHODS_FAILURE,
  payload: { error },
});
